"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const headerFooterService_1 = require("./service/headerFooterService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('headerFooter/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const headerFooterService = new headerFooterService_1.HeaderFooterService(Env_1.APIPATHENV);
        const response = yield headerFooterService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in fetching header footer");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('headerFooter/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const headerFooterService = new headerFooterService_1.HeaderFooterService(Env_1.APIPATHENV);
        const response = yield headerFooterService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in creating header footer");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('headerFooter/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const headerFooterService = new headerFooterService_1.HeaderFooterService(Env_1.APIPATHENV);
        const response = yield headerFooterService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in updating header footer");
    }
}));
